import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'OptionView';
const BASE_URL = 'https://optionview.in';
const DEFAULT_DESCRIPTION =
  'Free Implied Volatility calculator for Indian F&O markets. Get IV Rank, IV Percentile and 90-day charts for NIFTY, Bank Nifty and 50 NIFTY stocks.';

export default function SEOHead({
  title,
  description = DEFAULT_DESCRIPTION,
  keywords = '',
  canonicalPath = '/',
  image = null,
  article = null,
}) {
  const fullTitle = title
    ? `${title} | ${SITE_NAME}`
    : `${SITE_NAME} — Free IV Calculator for Indian Markets`;
  const canonicalUrl = `${BASE_URL}${canonicalPath}`;
  const imageUrl = image
    ? (image.startsWith('http') ? image : `${BASE_URL}${image}`)
    : null;

  const articleSchema = article
    ? JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'Article',
        headline: title,
        description,
        author: {
          '@type': 'Person',
          name: article.author || 'OptionView Team',
        },
        publisher: {
          '@type': 'Organization',
          name: 'OptionView',
          url: BASE_URL,
        },
        datePublished: article.datePublished,
        ...(imageUrl ? { image: imageUrl } : {}),
        url: canonicalUrl,
      })
    : null;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:site_name" content={SITE_NAME} />
      {imageUrl && <meta property="og:image" content={imageUrl} />}
      {article && <meta property="og:type" content="article" />}

      {/* Twitter Card */}
      <meta name="twitter:card" content={imageUrl ? 'summary_large_image' : 'summary'} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      {imageUrl && <meta name="twitter:image" content={imageUrl} />}

      {/* Article JSON-LD */}
      {articleSchema && (
        <script type="application/ld+json">{articleSchema}</script>
      )}
    </Helmet>
  );
}
